import { Injectable, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, Subject as RxjsSubject } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { StorageService } from './storage.service';
import { LANGUAGE } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class LangUpdateService implements OnDestroy {

  private currentLanguage = new BehaviorSubject<string>(LANGUAGE.ENGLISH); // First initiation will always be english

  public currentLanguageChanged = this.currentLanguage.asObservable();
  public onPaginatorLabelChange$ = new RxjsSubject<boolean>();

  constructor(private storageService: StorageService) {
  }

  ngOnDestroy(): void {
    this.onPaginatorLabelChange$.unsubscribe();
  }

  public updateLanguage(lang: string) {
    this.currentLanguage.next(lang);
    this.storageService.pushCurrentLanguage(lang);
    this.paginatorLabelChangeEmit();
  }

  public register(onDestroy: Observable<any>, sub: (res: any) => void = null) {
    this.currentLanguageChanged.pipe(takeUntil(onDestroy)).subscribe(lang => {
      sub(lang);
    });
  }

  public prepare(
    translate: TranslateService,
    onDestroy: Observable<any>,
    sub: (response: any) => void = null
  ) {
    return this.currentLanguageChanged
      .pipe(
        filter(language => translate.currentLang !== language),
        switchMap(language => translate.use(language)),
        takeUntil(onDestroy)
      )
      .subscribe(response => sub?.(response));
  }

  public getLang() {
    return this.currentLanguage.getValue();
  }

  paginatorLabelChangeObs(): Observable<boolean> {
    return this.onPaginatorLabelChange$;
  }

  paginatorLabelChangeEmit() {
    this.onPaginatorLabelChange$.next(true);
  }
}
